/**
 * 카드결제 전표를 불러톡으로 공유 ($j.F.Admin.CardPay.ReceiptShare).
 *
 * 어느 관리자 화면(카드결제 현황·기사편집 등)에서 호출해도 되는 정적 유틸이다 —
 * 결제상세 조회 → 전표 캡처 → 업로드+발송까지 `send(paymentNum)` 한 호출로 끝난다.
 *
 * 저장소에 서버측 HTML→이미지 렌더러가 없다(html2canvas 만 쓰고 전부 클라이언트 캡처) — 그래서 전표 이미지도 여기서
 * 오프스크린 DOM 을 그려 캡처한다. 전표는 회원 앱·관리자 상세와 같은 공용 전표($j.F.CardReceipt)다.
 * 종이 전표 이미지라 관리자 다크·테마와 무관하게 흰 바탕으로 찍힌다(전표 토큰 기본값) — 기사편집 같은 다른 페이지에서 불러도 같다.
 *
 * 발신자는 관리자 본인이 아니라 관리자 계정에 연결된 앱회원(manager_appmbno)이다(서버가 판정).
 * 그 앱회원이 없는 관리자는 서버가 실패 메시지를 돌려준다.
 */
export default class ReceiptShare {
    /** @param {number} paymentNum g5_card_payment.num */
    static async send(paymentNum) {
        const num = parseInt(paymentNum, 10);
        if (!num) return;

        let item;
        try {
            item = await ReceiptShare._fetchDetail(num);
        } catch (e) {
            ReceiptShare._toast('error', e.message);
            return;
        }

        if (!confirm(`${item.payerName || '기사'}님에게 전표를 불러톡으로 보낼까요?`)) return;

        try {
            await ReceiptShare._ensureHtml2Canvas();
            const dataUrl = await ReceiptShare._capture(item);
            ReceiptShare._removeCapture();
            ReceiptShare._post(num, dataUrl);
        } catch (e) {
            ReceiptShare._removeCapture();
            ReceiptShare._toast('error', e.message || '전표를 만들지 못했습니다.');
        }
    }

    static _post(num, dataUrl) {
        $.ajax({
            type: 'post',
            url: `/adm/ajax/cardpay/${num}/share-receipt`,
            data: { image: dataUrl },
            dataType: 'json',
            success(res) {
                if (res && res.success) {
                    ReceiptShare._toast('success', '전표를 불러톡으로 보냈습니다.');
                } else {
                    ReceiptShare._toast('error', (res && res.message) || '전송에 실패했습니다.');
                }
            },
            error() { ReceiptShare._toast('error', '요청 처리중 오류가 발생했습니다.'); },
        });
    }

    static _toast(kind, msg) {
        if (window.$j && $j.F && $j.F.Admin && $j.F.Admin.Util && $j.F.Admin.Util.tsalert) {
            $j.F.Admin.Util.tsalert(kind, msg);
        } else {
            alert(msg);
        }
    }

    static _fetchDetail(num) {
        return new Promise((resolve, reject) => {
            $.post('/adm/ajax/cardpay/payments/detail', { num }, (res) => {
                if (res && res.success) resolve(res.item);
                else reject(new Error((res && res.message) || '내역을 찾을 수 없습니다.'));
            }).fail(() => reject(new Error('내역 조회에 실패했습니다.')));
        });
    }

    /** 전표저장(`Pages/Mobile/CardPay.js`)과 같은 로컬 vendor 경로 — CDN 의존 없앰 */
    static _ensureHtml2Canvas() {
        return new Promise((resolve, reject) => {
            if (window.html2canvas) return resolve();
            let s = document.querySelector('script[data-rc-h2c]');
            if (s) { s.addEventListener('load', () => resolve()); s.addEventListener('error', reject); return; }
            s = document.createElement('script');
            s.src = '/js/vendor/html2canvas.1.4.1.min.js';
            s.async = true;
            s.setAttribute('data-rc-h2c', '1');
            s.onload = () => resolve();
            s.onerror = () => reject(new Error('전표 캡처 라이브러리를 불러오지 못했습니다.'));
            document.head.appendChild(s);
        });
    }

    /** 전표를 오프스크린 DOM 에 그리고 html2canvas 로 캡처한다 */
    static async _capture(item) {
        // 공용 전표 그대로 — 스타일(.ui-receipt)은 관리자 번들에 있고 토큰 기본값이 흰 종이라 어느 관리자 화면에서 불러도 같게 찍힌다
        const html = `<div id="jb-rc-capture" style="position:fixed;left:-9999px;top:0;width:360px;background:#fff">`
            + $j.F.CardReceipt.build(item, { cancel: !!item.x }) + '</div>';

        $(document.body).append(html);
        const $cap = $('#jb-rc-capture');
        const canvas = await window.html2canvas($cap[0], { backgroundColor: '#fff', scale: 2, useCORS: true });
        return canvas.toDataURL('image/jpeg', 0.92);
    }

    static _removeCapture() {
        $('#jb-rc-capture').remove();
    }
}
